import type { DocumentNode } from '@apollo/client/index.js'
import { devThrowError } from '@ecomm/error-handling'
import { voidFn } from '@simplisafe/ewok'

/**
 * Looks at a graphql query and validates that it has the required variables for `locale` and `preview`.
 */
export const validateQuery = (query: DocumentNode) => {
  const operation = query?.definitions.find(t => {
    return t.kind === 'OperationDefinition'
  })

  const name =
    operation?.kind === 'OperationDefinition' ? operation.name : 'unknown query'

  const variables =
    operation?.kind === 'OperationDefinition'
      ? operation.variableDefinitions?.map(t => {
          return t.variable.name.value
        })
      : []

  if (operation && variables) {
    ;['preview', 'locale'].forEach(t => {
      if (variables?.includes(t)) {
        voidFn()
        return
      } else {
        devThrowError(Error(`Query is missing a required variable: ${t}`))
        return
      }
    })
    return
  } else if (operation) {
    // this else branch isn't really ever possible to hit, but handling the error just in case.
    devThrowError(
      Error(
        `Query ${JSON.stringify(name)} is missing required variables: locale and preview`
      )
    )
    return
  } else {
    // This is when the query is just a fragment
    voidFn()
    return
  }
}
